import moment, { Moment, MomentInput } from 'moment-timezone';
import { history } from '../store';

export const handleDateURLParams = (fromDate: MomentInput, toDate: MomentInput) => {
  const { state, search } = history.location;
  const searchParams = new URLSearchParams(search);

  searchParams.set('fromDate', moment(fromDate).format());
  searchParams.set('toDate', moment(toDate).format());

  history.replace({
    state,
    search: searchParams.toString(),
  });
};

export const initDatesFromURL = () => {
  let initialFromDate: Moment | null = null,
    initialToDate: Moment | null = null;
  const url = new URL(window.location.href);
  const fromDateParam = url.searchParams.get('fromDate');
  const toDateParam = url.searchParams.get('toDate');
  if (fromDateParam && moment(decodeURIComponent(fromDateParam)).isValid()) {
    initialFromDate = moment(decodeURIComponent(fromDateParam)).startOf('day');
  }
  if (toDateParam && moment(decodeURIComponent(toDateParam)).isValid()) {
    initialToDate = moment(decodeURIComponent(toDateParam)).endOf('day');
  }
  return {
    fromDate: initialFromDate,
    toDate: initialToDate,
  };
};

/**
 * Add new query params to the current query params
 *
 * @param currentQueryParams The current query params object
 * @param newQueryParams The new query params to add
 *
 * @returns The new query params, without the `?`
 */
export function addURLParams(
  currentQueryParams: Record<string, string>,
  newQueryParams: Record<string, string>,
): string {
  // decode the current query params
  const decodedCurrentParams: Record<string, string> = {};
  Object.entries(currentQueryParams).forEach(([k, v]) => (decodedCurrentParams[k] = decodeURIComponent(v)));

  const currentParams = new URLSearchParams(decodedCurrentParams);
  for (const key in newQueryParams) {
    const value = newQueryParams[key];
    currentParams.set(key, String(value));
  }
  return currentParams.toString();
}

/** Returns a search string with `fromDate` and `toDate` if both are set, otherwise an empty string */
export function getDatesSearch(fromDate: Moment | null, toDate: Moment | null) {
  return fromDate && toDate ? `?${new URLSearchParams({ fromDate: fromDate.format(), toDate: toDate.format() })}` : '';
}
